import React from 'react';
import { Menu, MenuItems, MenuButton } from '@headlessui/react';
import Icon from 'flow/components/ui-components/Icon';
import MenuItem from 'flow/components/ui-components/MenuItem';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import {
    selectSelectedOperatorQueuesSortingData,
    selectSelectedQueueDescription,
} from 'flow/selectors/SupervisorSelectors';
import { QueueKey } from 'flow/types/EntityKeys';
import { setSelectedQueue } from 'flow/actions/SupervisorActions';

const QueuesDropdownMenu = () => {
    const { i18next } = useAppContext();
    const description = useAppSelector(selectSelectedQueueDescription);

    return (
        <Menu as="div" className="relative text-left">
            {({ open }) => (
                <>
                    <MenuButton className="hover:darken-10 inline-flex w-full min-w-64 items-center justify-between rounded-sm bg-gray-200 px-3 py-2 text-sm font-bold text-gray-800">
                        {description === 'all'
                            ? i18next.t('general.all')
                            : description}
                        <Icon iconKey="arrow_down" />
                    </MenuButton>
                    {open && <InternalMenuItems />}
                </>
            )}
        </Menu>
    );
};

export default QueuesDropdownMenu;

const InternalMenuItems = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();
    const queues = useAppSelector(selectSelectedOperatorQueuesSortingData);
    const onItemClick = (key: 'all' | QueueKey) => {
        dispatch(setSelectedQueue(key));
    };

    return (
        <MenuItems className="scrollbar shadow-base absolute end-0 z-20 mt-2 max-h-72 w-full origin-top-right rounded-md bg-white p-3 outline-gray-100 focus:outline">
            <MenuItem key={'mi-queues-all'} onClick={() => onItemClick('all')}>
                <span>{i18next.t('general.all')}</span>
            </MenuItem>
            {queues?.valueSeq().map((queue) => (
                <MenuItem
                    key={`mi-${queue.get('key')}`}
                    onClick={() => onItemClick(queue.get('key'))}
                >
                    <span>{queue.get('description')}</span>
                </MenuItem>
            ))}
        </MenuItems>
    );
};
